var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1456 24.9338C36.7519 24.9338 36.4229 24.6048 36.4229 24.2111V12.3098L22.7768 10.6287C22.383 10.5809 22.1018 10.219 22.1474 9.82741C22.1931 9.43579 22.5571 9.15243 22.9487 9.19806L37.2401 10.9598C37.602 11.0076 37.8694 11.3217 37.8694 11.6825V24.2291C37.8683 24.6186 37.5553 24.9338 37.1456 24.9338Z",
    fill: "#747474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2436 18.6129C12.2595 20.0266 13.1404 21.3489 14.6177 22.1184C19.7427 24.8225 25.8738 24.8225 30.9998 22.1184C32.4782 21.3319 33.3739 20.0276 33.3739 18.6129L33.3899 14.9026L23.1866 21.3638C23.0603 21.4413 22.9351 21.4742 22.7929 21.4742C22.6506 21.4742 22.5254 21.4423 22.3991 21.3638L12.1799 14.8867L12.2436 18.6129Z",
    fill: "#747474"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13232 9.93582L22.8225 19.8876L33.1202 13.3468L25.4492 12.4044C25.2454 12.6081 25.0236 12.7981 24.788 12.9552L24.7561 12.9711L24.6946 13.0029C24.113 13.3649 23.4529 13.5378 22.8076 13.5378C22.1464 13.5378 21.4874 13.3638 20.9206 13.0029L20.8591 12.9711L20.8272 12.9552C19.1621 11.9024 18.6739 9.70233 19.7267 8.03398C19.7267 8.03398 19.7267 8.03398 19.7267 8.01806C20.026 7.56277 20.3879 7.20087 20.8113 6.93342L20.8591 6.90158C20.875 6.88566 20.875 6.88566 20.8909 6.88566C22.0552 6.16292 23.5473 6.16292 24.7116 6.88566C24.7275 6.88566 24.7275 6.90158 24.7434 6.90158L24.805 6.94934C25.2603 7.24862 25.6381 7.64024 25.9214 8.09766L37.3972 9.5113C37.8069 9.55906 38.1677 9.71507 38.4818 9.96659L38.5137 9.95067L22.8065 0L7.13232 9.93582Z",
    fill: "#747474"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9525 8.81938C20.3391 9.79364 20.6235 11.098 21.5978 11.7273L21.6456 11.7592C21.6615 11.7592 21.6615 11.7751 21.6774 11.7751C22.0393 12.0107 22.4638 12.1041 22.8873 12.1041L22.588 12.0722C21.394 11.93 20.545 10.8305 20.701 9.65143C20.7488 9.25769 20.9048 8.91277 21.1266 8.61243C21.0629 8.66125 21.0152 8.74084 20.9525 8.81938Z",
    fill: "#747474"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3999 30.8333C41.3999 30.4117 41.0549 30.0667 40.6332 30.0667H1.5332V31.6H40.6332C41.0549 31.6 41.3999 31.255 41.3999 30.8333Z",
    fill: "#C4C4C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1665 27H1.5332V28.5333H40.6332C41.8982 28.5333 42.9332 29.5683 42.9332 30.8333C42.9332 32.0983 41.8982 33.1333 40.6332 33.1333H1.5332V34.6667H42.1665C44.2845 34.6667 45.9999 32.9513 45.9999 30.8333C45.9999 28.7154 44.2845 27 42.1665 27Z",
    fill: "#747474"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59985 40.0335C4.59985 40.4552 4.94485 40.8002 5.36652 40.8002H44.4665V39.2668H5.36652C4.94485 39.2668 4.59985 39.6118 4.59985 40.0335Z",
    fill: "#C4C4C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.0334C0 42.1513 1.71542 43.8667 3.83333 43.8667H44.4667V42.3334H5.36667C4.10167 42.3334 3.06667 41.2984 3.06667 40.0334C3.06667 38.7684 4.10167 37.7334 5.36667 37.7334H44.4667V36.2001H3.83333C1.71542 36.2001 0 37.9155 0 40.0334Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon-4.3c49459366d320c57ac8e684fab1da2d.svg";
export { ForwardRef as ReactComponent };